import { useQuery } from "@tanstack/react-query";
import { FileDown, FileCheck2 } from "lucide-react";
import { gov, downloadFile } from "@/lib/governanceApi";

export const CustomerAssurance = () => {
  const { data: agreements = [] } = useQuery({ queryKey: ["my-agreements"], queryFn: gov.myAgreements });
  const { data: docs = [] } = useQuery({ queryKey: ["my-docs"], queryFn: gov.myDocuments });
  const row = "flex items-center justify-between px-5 py-3 border-b border-zinc-100 last:border-0 text-sm";
  return (
    <div className="border-2 border-zinc-950 bg-white" data-testid="customer-assurance">
      <div className="px-5 py-3 border-b-2 border-zinc-100 text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500 flex items-center gap-2">
        <FileCheck2 size={13} /> Agreements & policies from Castlewood Software
      </div>
      {agreements.length === 0 && docs.length === 0 && <div className="px-5 py-4 text-sm text-zinc-400">No agreements or policies have been issued to your organisation yet.</div>}
      {agreements.map((a) => (
        <div key={a.id} className={row} data-testid={`my-agreement-${a.id}`}>
          <span><strong>{a.type.toUpperCase()}</strong> · {a.status} {a.signed_date && `· signed ${a.signed_date}`}</span>
          <button onClick={() => downloadFile(`/my/agreements/${a.id}/pdf`, `${a.type}.pdf`)} className="text-[#2F6DA3] flex items-center gap-1 font-bold text-xs"><FileDown size={13} /> PDF</button>
        </div>
      ))}
      {docs.map((d) => (
        <div key={d.id} className={row} data-testid={`my-doc-${d.id}`}>
          <span>{d.title} · v{d.version} · effective {d.effective_date}</span>
          <button onClick={() => downloadFile(`/my/documents/${d.id}/pdf`, `${d.title}.pdf`)} className="text-[#2F6DA3] flex items-center gap-1 font-bold text-xs"><FileDown size={13} /> PDF</button>
        </div>
      ))}
    </div>
  );
};
